import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from '../ofbiz-form-model';

@Component({
  selector: 'ngx-ofbiz-cell-checkbox',
  template: `<nb-checkbox [(ngModel)]="checked" (checkedChange)="toggle($event)"></nb-checkbox>`,
  styleUrls: ['./ofbiz-cell-checkbox.component.scss']
})
export class OfbizCellCheckboxComponent implements ViewCell, OnInit{
  value: string | number;
  rowData: any;
  @Input() field:any;
  checked:boolean;

  ngOnInit(): void {
    console.log(this.value)
    switch (this.value) {
      case "Y":
      case "TRUE":
      case "y":
      case "true":
      case "True":
        this.checked = true;
        break;
      case "N":
        case "FALSE":
        case "n":
        case "false":
        case "False":
          this.checked = false;
          break;
      default:
        break;
    }
  }

  toggle(e){
    if(this.checked != undefined){
      this.checked != this.checked;
    }else{
      console.log(e.value)
      this.checked = e.value
    }
    
  }


}
